import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { component } from '../../Decorators/Component';
import { CoreConfig } from '../../../CoreConfig';
import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { SmallView } from '../Typography/SmallView';
import { AnimatedPressable } from '../Buttons/AnimatedPressable';
import { useAnimation } from '../Animations/AnimationHooks';
export const SearchItemView = component({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.searchItem,
    style(theme, mediaQuery, window, props) {
        var _a, _b;
        let hover = (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.secondary_color;
        if (hover && hover.startsWith('rgb(')) {
            hover = hover.replace('rgb(', 'rgba(').replace(')', ', 0.4)');
        }
        return {
            container: {
                padding: props.size === 'sm'
                    ? 5
                    : 15
            },
            hover: {
                backgroundColor: hover || '#F1F4F9'
            },
            blur: {
                backgroundColor: '#fff'
            },
            hoverText: {
                backgroundColor: ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.secondary_color) || '#1155CC'
            },
            blurText: {
                backgroundColor: '#394E66'
            },
            text: {
                fontSize: props.size === 'sm'
                    ? 14
                    : 16,
                lineHeight: props.size === 'sm'
                    ? 22
                    : 24,
            }
        };
    }
})(({ style, value, getItem, testID, onPress }) => {
    var _a, _b, _c, _d;
    const [animation, setAnimation] = useAnimation({ initialValue: 0, nativeDriver: false });
    const text = useMemo(() => getItem(value), [value, getItem]);
    const handleHover = useCallback(() => setAnimation(1), []);
    const handleBlur = useCallback(() => setAnimation(0), []);
    const handlePress = useCallback(() => onPress === null || onPress === void 0 ? void 0 : onPress(value), [value, onPress]);
    const backgroundColor = animation.interpolate({
        inputRange: [0, 1],
        outputRange: [(_a = style === null || style === void 0 ? void 0 : style.blur) === null || _a === void 0 ? void 0 : _a.backgroundColor, (_b = style === null || style === void 0 ? void 0 : style.hover) === null || _b === void 0 ? void 0 : _b.backgroundColor]
    });
    const color = animation.interpolate({
        inputRange: [0, 1],
        outputRange: [(_c = style === null || style === void 0 ? void 0 : style.blurText) === null || _c === void 0 ? void 0 : _c.backgroundColor, (_d = style === null || style === void 0 ? void 0 : style.hoverText) === null || _d === void 0 ? void 0 : _d.backgroundColor]
    });
    return (_jsx(AnimatedPressable, { testID: testID, style: [style === null || style === void 0 ? void 0 : style.container, { backgroundColor }], onPress: handlePress, onMouseEnter: handleHover,
        onMouseLeave: handleBlur, children: _jsx(SmallView, { textStyle: [style === null || style === void 0 ? void 0 : style.text, { color }], children: text }) }));
});
